import React, { FC, useState } from 'react'
import AudioSwitch from '../AudioSwitch'
import { AudioSelectorProps } from './types'
import DialInRegionSelector from '../DialInRegionSelector'
import MicrophoneSelector from '../MicrophoneSelector'
import { AudioSource } from '../../dataStore/reducers/tracks/tracksReducerDefaultState'
import Label from '@bt-react/components/Label'
import style from './AudioSelector.module.scss'

export const AudioSelector: FC<AudioSelectorProps> = ({ isDialInAvailable = false, isDialInConnected = false, selectedMicrophoneDeviceId, onMicrophoneChange, onAudioSourceChange }) => {

  const [ selectedAudioSource, setSelectedAudioSource ] = useState<AudioSource>('microphone')
  const audioLabel = 'Audio type (select type)'

  const handleSwitchClick = (selectedAudioSource: AudioSource) => {

    setSelectedAudioSource(selectedAudioSource)
    if (onAudioSourceChange) onAudioSourceChange(selectedAudioSource)

  }

  return <div data-bdd='audio-selector'>
    <Label className={style['AudioSelector-Label']}>{audioLabel}</Label>
    {
      isDialInAvailable &&
      <AudioSwitch
        selected={selectedAudioSource}
        onClick={handleSwitchClick}
      />
    }
    {
      selectedAudioSource === 'microphone' || !isDialInAvailable
        ? <MicrophoneSelector
          onMicrophoneChange={onMicrophoneChange}
          selectedMicrophone={selectedMicrophoneDeviceId}
          isDialInConnected={isDialInConnected}
        />
        : <DialInRegionSelector />
    }
  </div>

}

export default AudioSelector
